import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { 
  ShoppingCart, 
  Smartphone, 
  Globe,
  Store, 
  ShieldCheck, 
  Zap, 
  LineChart, 
  Settings, 
  PanelRight
} from 'lucide-react';

const ShopwareFeaturesList = () => {
  return (
    <section id="shopware-features" className="py-16 md:py-24 bg-white">
      <div className="container">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-5xl font-bold mb-4">
            Warum deinen Shopware Online-Shop von uns programmieren lassen?
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Wir bieten dir nicht nur Entwicklung, sondern eine Komplett-Lösung für deinen E-Commerce Erfolg.
            Als erfahrene Shopware Agentur setzen wir auf bewährte Technologien und Best Practices.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <ShoppingCart className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">B2B & B2C Spezialisierung</h3>
              <p className="text-gray-600">
                Ob Endkunden-Shop oder komplexe B2B-Plattform – wir programmieren deinen Shopware Shop 
                exakt nach deinen Anforderungen mit allen benötigten Funktionen.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zu B2B-Shops &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Smartphone className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Mobile-First Design</h3>
              <p className="text-gray-600">
                Perfekt für alle Geräte: Unsere Shopware Shops bieten optimale Benutzererfahrung auf 
                Smartphones, Tablets und Desktops – für maximale Conversion-Raten.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zum Mobile-First Ansatz &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <LineChart className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Conversion-Optimierung</h3>
              <p className="text-gray-600">
                Durch gezielte UX/UI-Optimierungen steigern wir nachweislich deine Conversion-Rate. 
                Wir bauen psychologische Trigger und bewährte Verkaufsmechanismen ein.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zur Conversion-Optimierung &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Zap className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Nahtlose ERP-Integration</h3>
              <p className="text-gray-600">
                Wir verbinden deinen Shopware Shop mit allen relevanten Systemen: ERP, CRM, PIM, 
                Zahlungsanbieter, Buchhaltung und Logistik für automatisierte Prozesse.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Erfahre mehr über Integrationen &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Globe className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Mehrsprachige Shops</h3>
              <p className="text-gray-600">
                International verkaufen? Wir programmieren deinen Shopware Shop mehrsprachig und 
                berücksichtigen lokale Besonderheiten, Währungen und Steuerregeln.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zu internationalen Shops &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Store className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Marktplatz-Anbindung</h3>
              <p className="text-gray-600">
                Dein Shop plus Marktplätze: Wir verbinden deinen Shopware Shop nahtlos mit Amazon, 
                eBay, Otto und anderen Verkaufskanälen für maximale Reichweite.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zu Marktplatz-Anbindungen &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <Settings className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Individuelle Funktionen</h3>
              <p className="text-gray-600">
                Spezielle Anforderungen? Kein Problem! Wir programmieren maßgeschneiderte Shopware-Plugins 
                und Features exakt nach deinen Geschäftsprozessen.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Beispiele individueller Features &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <ShieldCheck className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Sicherheit & Compliance</h3>
              <p className="text-gray-600">
                DSGVO-konform und sicher: Wir entwickeln deinen Shopware Shop nach aktuellen 
                Sicherheitsstandards und rechtlichen Vorgaben für maximalen Schutz.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zu Sicherheitsmerkmalen &rarr;</span>
              </div>
            </CardContent>
          </Card>

          <Card className="bg-white border-2 hover:border-blue-300 hover:shadow-md transition-all duration-300">
            <CardContent className="p-6 flex flex-col items-start h-full">
              <div className="rounded-full bg-blue-100 p-3 mb-4">
                <PanelRight className="h-6 w-6 text-blue-600" />
              </div>
              <h3 className="text-xl font-bold mb-3">Analytics & Dashboard</h3>
              <p className="text-gray-600">
                Volle Kontrolle: Wir integrieren individuelle Dashboards und Analytics-Lösungen, 
                damit du alle wichtigen Kennzahlen immer im Blick hast.
              </p>
              <div className="mt-auto pt-4">
                <span className="text-sm text-blue-700 font-medium">Mehr zu Analytics-Features &rarr;</span>
              </div>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default ShopwareFeaturesList; 